var _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEditTableIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    stroke: "#0176BC",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: "#0176BC"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 15,
    height: 3,
    fill: "#0176BC",
    stroke: "#0176BC"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 3.5,
    width: 15,
    height: 4.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 15,
    height: 13
  }), /*#__PURE__*/React.createElement("line", {
    x1: 5.5,
    y1: 0.5,
    x2: 5.5,
    y2: 13.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 10.5,
    y1: 0.5,
    x2: 10.5,
    y2: 13.5
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    fill: "#FFFFFF",
    stroke: "#0176BC",
    strokeWidth: 0.5
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 14.5,
    cy: 12.5,
    r: 4.3
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0176BC",
    d: "M12,13.8367 V14.8462 H13.0095 L15.9868,11.8689 L14.9773,10.8594 L12,13.8367 Z M16.7674,11.0882 C16.8724,10.9832 16.8724,10.8136 16.7674,10.7087 L16.1375,10.0787 C16.0325,9.97375 15.8629,9.97375 15.7579,10.0787 L15.2653,10.5714 L16.2748,11.5808 L16.7674,11.0882 Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditTableIcon);
export default __webpack_public_path__ + "static/media/EditTableIcon.f3904d21.svg";
export { ForwardRef as ReactComponent };